<template>
    <div>
        <label for="login">Логин</label>
        <b-form-input type="text" v-model="login" name="login" :state="inputState(login)" />
        <label for="password">Пароль</label>
        <b-form-input type="password" v-model="password" name="password" :state="inputState(password)" />
        <label for="re_password">Повторить пароль</label>
        <b-form-input type="password" v-model="re_password" name="re_password" :state="inputState(re_password)" />
        <button 
            class="btn btn-success" 
            style="position: absolute; bottom: 10px;"
            @click="updateLoginAndPassword"
        >
            Сохранить
        </button>
    </div>
</template>

<script>
import Data from '../API';
export default {
    data() {
        return {
            login: '',
            password: '',
            re_password: ''
        }
    },
    methods: {
        inputState(i) {
            return Boolean(i);
        },
        updateLoginAndPassword() {
            if (this.login && this.password && this.re_password && this.password == this.re_password) {
                Data.reLoginAndPassword({
                    token: localStorage.getItem('token'),
                    admin: this.login,
                    password: this.password
                })
                .then(resp => {
                    if (resp) {
                        this.$emit('save');
                    }
                })
            } else {
                alert('Не верно заполнены поля');
            }
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/adminSettings.vue